import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CookiesService } from '../services/cookies.service';
import { COOKIE_CLAVE_NAME } from '../../types/aclave';
import { catchError, of, tap } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export function LoginGuard(): CanActivateFn {
    return () => {
        const router = inject(Router);
        const authService = inject(AuthService);

        if (!authService.isLoggedIn()) {
            console.error('You are not allowed to see this page');
            router.navigate(['/notaccesible']);
            return false;
        }

        return true;
    };
}

export function LogoutGuard(): CanActivateFn {
    return () => {
        const router = inject(Router);
        const authService = inject(AuthService);

        if (!authService.isLoggedIn()) {
            return true;
        } else {
            console.error('You are not allowed to see this page');
            router.navigate(['/notaccesible']);
            return false;
        }
    };
}

export function ActionGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const router = inject(Router);
        const authService = inject(AuthService);
        let user = authService.getLoggedInUser()!;

        if (user.getAction(route.data.actionCode).Visible) {
            return true;
        } else {
            console.error('You are not allowed to see this page');
            router.navigate(['/notaccesible']);
            return false;
        }
    };
}

export function LoginClaveGuard(): CanActivateFn {
    return () => {
        const router = inject(Router);
        const cookiesService = inject(CookiesService);
        const authService = inject(AuthService);
        const notificationService = inject(NotificationService);
        const XMLSignedId = cookiesService.getCookie(COOKIE_CLAVE_NAME);

        if (!XMLSignedId) {
            router.navigate(['/error/notauthorized']);
            return false;
        }

        const tokenResponse = authService.getLoggedInUser()?.TokenResponse;
        if (tokenResponse) {
            router.navigate(['/home']);
            return true;
        }

        return refreshToken(router, authService, notificationService);
    };

    function refreshToken(router: Router, authService: AuthService, notificationService: NotificationService): boolean {
        authService
            .refreshTokenClave()
            .pipe(
                tap((res: any) => {
                    if (!res) {
                        console.error('KO Refresh Clave.');
                        notificationService.addErrorMessage('Error de autorización');
                        router.navigate(['/error/loginko']);
                    } else {
                        notificationService.addSuccessMessage('Sesión iniciada');
                        router.navigate(['/home']);
                        authService.emitLogin('');
                    }
                    return res;
                }),
                catchError((error: any) => {
                    console.error('KO Refresh Clave');
                    notificationService.addErrorMessage('Error de autenticación');
                    router.navigate(['/error/loginko']);
                    return of(false);
                }),
            )
            .subscribe();
        return true;
    }
}
